<template>
  <v-menu offset-y>
    <template #activator="{ on }">
      <v-btn height="100%" text v-on="on" class="text-none">
        <v-avatar
          size="32"
          class="cursor-pointer"
          :class="{ 'elevation-2': !avatar }"
        >
          <v-img
            v-if="isLogin"
            :src="avatar || require(`@/assets/icons/avatar.svg`)"
          />
          <v-icon v-else>mdi-account</v-icon>
        </v-avatar>

        <SizeBox width="4" />
        <div>
          <div class="Medium">{{ Team.nickname }}</div>
        </div>

        <SizeBox width="16" />

        <v-icon>mdi-chevron-down</v-icon>
      </v-btn>
    </template>

    <v-list>
      <v-list-item @click="$store.dispatch('auth/DO_LOGOUT')">
        {{ $t('SIDEBAR.NAV.ITEM.SIGN_OUT') }}
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters({
      logStatus: 'auth/getLogStatus',
      Team: 'auth/getTeam',
      User: 'auth/getUser'
    }),
    isLogin() {
      return this.logStatus === 'login';
    },
    avatar() {
      return this.Team && this.Team.avatar && this.Team.avatar.url;
    }
  }
};
</script>

<style lang="scss" scoped>
//
</style>
